import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex no-wrap items-start" }
const _hoisted_2 = {
  key: 0,
  class: "flex column flex-1 q-ml-sm"
}

import _ from 'lodash'
import { computed } from 'vue'

interface IProps {
  modelValue: unknown[] | boolean | null
  checkboxClass?: string | (string | Record<PropertyKey, boolean>)[] | Record<PropertyKey, boolean>
  value?: number | string | Record<PropertyKey, unknown> | null | undefined
  icon?: string
  label?: string
  description?: string
  error?: boolean
  errorMessage?: string
  disable?: boolean
}

interface IEmits {
  (event: 'update:modelValue', data: unknown[] | boolean | null): void
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KCheckbox' },
  __name: 'KCheckbox',
  props: {
    modelValue: { type: [Array, Boolean, null] },
    checkboxClass: { default: 'q-mr-sm' },
    value: { default: null },
    icon: { default: '' },
    label: { default: '' },
    description: { default: '' },
    error: { type: Boolean, default: false },
    errorMessage: { default: '' },
    disable: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {



const props = __props

const emit = __emit

const isChecked = computed(() => {
  if (props.modelValue == null) return false
  if (typeof props.modelValue === 'boolean') return props.modelValue
  return hasValueInArray()
})

const handleCheckbox = () => {
  if (!props.disable) {
    if (props.modelValue == null) return emit('update:modelValue', false)

    if (typeof props.modelValue === 'boolean') return emit('update:modelValue', !props.modelValue)

    let newModelValue = [...props.modelValue]
    // NOTE: that means Checkbox was selected and want to deselect
    if (hasValueInArray()) newModelValue = newModelValue.filter((val) => !_.isEqual(val, props.value))
    else newModelValue.push(props.value)

    emit('update:modelValue', newModelValue)
    newModelValue = []
  }
}

const hasValueInArray = () => {
  if (!Array.isArray(props.modelValue)) return false
  return props.modelValue.findIndex((val) => _.isEqual(val, props.value)) !== -1
}

__expose({
  click: handleCheckbox,
})

return (_ctx: any,_cache: any) => {
  const _component_KIcon = _resolveComponent("KIcon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("input", {
        class: "hidden",
        type: "checkbox"
      }, null, -1)),
      _createElementVNode("div", {
        class: _normalizeClass(["k-checkbox__input flex items-center justify-center transition", [
          {
            'k-checkbox__input--active': isChecked.value || __props.modelValue == null,
            'k-checkbox__input--error': __props.error,
            'k-checkbox__input--disable cursor-not-allowed': __props.disable,
            'cursor-pointer': !__props.disable,
            'self-start': __props.icon && __props.description,
          },
          __props.checkboxClass,
        ]]),
        onClick: handleCheckbox
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["transition k-checkbox__input-bullet flex items-center justify-center", {
            'k-checkbox__input-bullet--active': !__props.disable && (isChecked.value || __props.modelValue == null),
            'k-checkbox__input-bullet--active-error': !__props.disable && isChecked.value && __props.error,
            'k-checkbox__input-bullet--disable': __props.disable,
          }])
        }, [
          _createVNode(_component_KIcon, {
            name: __props.modelValue !== null ? 'tick' : 'minus',
            size: "20px",
            color: __props.modelValue == null ? 'white' : __props.error ? 'error-100' : 'white'
          }, null, 8, ["name", "color"])
        ], 2),
        _renderSlot(_ctx.$slots, "inner-checkbox")
      ], 2),
      (__props.label)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (__props.label)
              ? (_openBlock(), _createElementBlock("label", {
                  key: 0,
                  class: _normalizeClass(["k-checkbox__label flex items-center justify-between transition cursor-pointer q-mb-none fw-500 fs-15px", [
            !__props.disable ? 'text-cool-gray-100' : 'text-cool-gray-60',
            {
              'cursor-not-allowed': __props.disable,
            },
          ]]),
                  onClick: handleCheckbox
                }, _toDisplayString(__props.label), 3))
              : _createCommentVNode("", true),
            (__props.description)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  class: _normalizeClass(["transition q-mb-none q-mt-sm fw-400 fs-14px", [__props.disable ? 'text-cool-gray-60' : 'text-cool-gray-70']])
                }, _toDisplayString(__props.description), 3))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (__props.icon)
        ? (_openBlock(), _createBlock(_component_KIcon, {
            key: 1,
            name: __props.icon,
            size: "32px",
            color: !__props.disable ? 'cool-gray-100' : 'cool-gray-60'
          }, null, 8, ["name", "color"]))
        : _createCommentVNode("", true)
    ]),
    (__props.error && __props.errorMessage)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: _normalizeClass(["q-mt-xs q-mb-none fw-400 fs-14px text-error-100", { 'q-ml-30': __props.description }])
        }, _toDisplayString(__props.errorMessage), 3))
      : _createCommentVNode("", true)
  ]))
}
}

})